import type { LocationQuery } from '#vue-router'

export const removeDatesAndHoursFromCamperQuery = (query: LocationQuery): LocationQuery => {
  const { date_from, date_to, hour_to, hour_from, ...rest } = query
  return rest
}
